<template>
  <q-dialog v-model="alert" persistent transition-show="fade" transition-hide="fade">
    <div class="hris-modal hris-modal-lg">
      <div class="hris-modal-header">
        <div class="row items-center no-wrap" style="gap: 16px; flex: 1; min-width: 0;">
          <div class="column items-center">
            <q-avatar size="72px" style="background: #E8EAED;">
              <img
                :src="uploadedImage ? getImagePreview(uploadedImage) : (userDataImage ? apiUrl + '/' + userDataImage : '/default-profile-avatar.svg')"
                alt="Profile Photo"
                @error="$event.target.onerror=null; $event.target.src='/default-profile-avatar.svg'"
              />
            </q-avatar>
            <q-btn
              dense
              unelevated
              class="hris-q-outline q-mt-sm"
              label="Change Photo"
              @click="getImage()"
            />
            <q-file
              style="display: none;"
              ref="file"
              clearable
              filled
              @change="handleFileChange"
              v-model="uploadedImage"
              label="Label"
            ></q-file>
          </div>
          <div style="min-width: 0;">
            <h2 class="hris-modal-title">{{ fullname }}</h2>
            <p class="hris-modal-subtitle">{{ position }}</p>
            <p class="hris-modal-subtitle">Time zone: {{ timeZone }}</p>
          </div>
        </div>
        <q-btn flat dense round v-close-popup aria-label="Close">
          <i class="fas fa-times"></i>
        </q-btn>
      </div>

      <div class="hris-modal-body">
        <div class="hris-form-row">
          <div class="hris-form-field">
            <q-field :value="employeeID" color="grey-8" label="Employee ID" stack-label outlined dense>
              <template v-slot:control>
                <div class="self-center full-width no-outline" tabindex="0">{{ employeeID }}</div>
              </template>
            </q-field>
          </div>
          <div class="hris-form-field">
            <q-field :value="dateHired" color="grey-8" label="Date Hired" stack-label outlined dense>
              <template v-slot:control>
                <div class="self-center full-width no-outline" tabindex="0">{{ dateHired }}</div>
              </template>
            </q-field>
          </div>
          <div class="hris-form-field">
            <q-field :value="department" color="grey-8" label="Department" stack-label outlined dense>
              <template v-slot:control>
                <div class="self-center full-width no-outline" tabindex="0">{{ department }}</div>
              </template>
            </q-field>
          </div>
        </div>

        <q-form ref="vForm" @submit="updateProfile">
          <div class="hris-form-row">
            <div class="hris-form-field">
              <q-input
                outlined
                dense
                color="green"
                v-model="email"
                label="Email Address"
                lazy-rules
                :rules="[formRules.required]"
              />
            </div>
            <div class="hris-form-field">
              <q-input
                outlined
                dense
                color="green"
                v-model="mobile"
                label="Mobile"
                lazy-rules
                :rules="[formRules.required]"
              />
            </div>
          </div>

          <div class="hris-form-row">
            <div class="hris-form-field" style="flex-basis: 100%;">
              <q-input
                outlined
                dense
                color="green"
                v-model="currentAddress"
                label="Current Address"
                :rules="[formRules.required]"
              />
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field" style="flex-basis: 100%;">
              <q-input
                outlined
                dense
                color="green"
                v-model="provincialAddress"
                label="Provincial Address"
                :rules="[formRules.required]"
              />
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field">
              <q-input
                outlined
                dense
                color="green"
                v-model="contactPerson"
                label="Emergency Contact Person"
                :rules="[formRules.required]"
              />
            </div>
            <div class="hris-form-field">
              <q-input
                outlined
                dense
                color="green"
                v-model="contactPersonRelation"
                label="Relationship"
                :rules="[formRules.required]"
              />
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field">
              <q-input
                outlined
                dense
                color="green"
                v-model="contactPersonMobile"
                label="Emergency Contact Mobile Number"
                :rules="[formRules.required]"
              />
            </div>
          </div>

          <div class="hris-modal-footer" style="border-top: none; padding: 8px 0 0;">
            <q-btn type="submit" unelevated class="hris-q-primary" label="Save changes" style="min-width: 140px;" />
          </div>
        </q-form>
      </div>
    </div>
  </q-dialog>
</template>
<script>
import axios from 'axios';

export default {
  name: 'ChangePassword',
  data: () => ({
    alert: false,
    fullname: null,
    position: null,
    employeeID: null,
    dateHired: null,
    department: null,
    username: null,
    status: null,
    email: null,
    mobile: null,
    currentAddress: null,
    provincialAddress: null,
    contactPerson: null,
    contactPersonRelation: null,
    contactPersonMobile: null,
    timeZone: null,
    apiUrl: process.env.VUE_APP_API_URL,
    uploadedImage: null,
    userDataImage: null, // for showing current image
    formRules: {
      required: val => !!val || 'This field is required'
    }
  }),

  computed: {
    token() {
      return this.$store.getters['auth/getToken'];
    },
    user() {
      return this.$store.getters['auth/getUser'];
    }
  },

  created() {
    this.eventHub.$on('myProfile', this.myProfile);
    this.displayData();
    this.getTimeZone();
  },

  methods: {
    myProfile(payload) {
      this.alert = payload.status;
    },

    closeModal() {
      this.alert = false;
    },

    displayData() {
      axios.create({
        baseURL: this.apiUrl,
        headers: { 'Authorization': `Bearer ${this.token}` }
      }).get(`/employee/profile`)
        .then((res) => {
          const data = res.data.data[0];
          this.employeeID = data.employee_id;
          this.position = data.position;
          this.fullname = data.fullname;
          this.username = data.username;
          this.email = data.email;
          this.department = data.department;
          this.dateHired = data.date_hired;
          this.status = data.status;
          this.mobile = data.mobile;
          this.currentAddress = data.currentAddress;
          this.provincialAddress = data.provincialAddress;
          this.contactPerson = data.contactPerson;
          this.contactPersonRelation = data.contactPersonRelation;
          this.contactPersonMobile = data.contactPersonMobile;
          this.userDataImage = data.image; // store current image
        });
    },

    updateProfile() {
      const formData = new FormData();
      formData.append("email", this.email);
      formData.append("mobile", this.mobile);
      formData.append("currentAddress", this.currentAddress);
      formData.append("provincialAddress", this.provincialAddress);
      formData.append("contactPerson", this.contactPerson);
      formData.append("contactPersonRelation", this.contactPersonRelation);
      formData.append("contactPersonMobile", this.contactPersonMobile);
      if (this.uploadedImage) formData.append("image", this.uploadedImage);

      axios.create({
        baseURL: this.apiUrl,
        headers: { 'Authorization': `Bearer ${this.token}` }
      }).post('/employee/profile/update', formData)
        .then(res => {
          this.$q.notify({
            color: 'green-7',
            textColor: 'white',
            icon: 'fa fa-check',
            message: 'Profile Updated!'
          });

          // Update local display image
          if (res.data.data && res.data.data.image) {
            this.userDataImage = res.data.data.image;
          }

          // Update Vuex Store (this also updates the cookie via mutation)
          let updatedUser = { ...this.user };
          updatedUser.image = res.data.data.image;
          updatedUser.email = this.email;
          updatedUser.mobile = this.mobile;

          this.$store.commit('auth/updateUser', updatedUser);

          // Reset the uploaded file
          this.uploadedImage = null;
        })
        .catch(err => {
          console.error(err);
          this.$q.notify({
            color: 'red-7',
            textColor: 'white',
            icon: 'fa fa-times',
            message: 'Profile update failed!'
          });
        });
    },

    async getTimeZone() {
      try {
        const res = await axios.create({
          baseURL: this.apiUrl,
          headers: { 'Authorization': `Bearer ${this.token}` }
        }).get('/current-time');
        this.timeZone = res.data.time_zone;
      } catch (error) {
        console.error('Error fetching time:', error);
        this.timeZone = 'Error fetching time';
      }
    },

    getImage() {
      this.$refs.file.pickFiles();
    },

    getImagePreview(file) {
      if (file instanceof File) {
        return URL.createObjectURL(file);
      }
      return '';
    },

    handleFileChange(file) {
      if (file && file.length > 0) {
        this.uploadedImage = file[0];
      }
    },
  }
};
</script>
